module.exports = __webpack_public_path__ + "img/swiper_3.5_1_1.c30d53d3.webp";